import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { RichText } from "../components/RichText";

const SLUGS = { confidentialite: true, "mentions-legales": true, cookies: true };

export default function LegalPage({ slug }) {
    const [page, setPage] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        setPage(null);
        setError("");
        if (!SLUGS[slug]) {
            setError("Page inconnue.");
            return;
        }
        api.get(`/public/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setError("Cette page n'est pas encore publiée."));
    }, [slug]);

    return (
        <main className="bg-cream min-h-screen pt-32 pb-24" data-testid={`legal-page-${slug}`}>
            <div className="container-bc max-w-3xl">
                {error && (
                    <div className="rounded-2xl border border-gold/40 bg-white p-8 text-center">
                        <p className="text-forest font-heading font-bold text-xl">{error}</p>
                        <Link to="/" className="text-gold underline mt-3 inline-block" data-testid="legal-back-home">Retour à l'accueil</Link>
                    </div>
                )}
                {page && (
                    <article className="rounded-3xl bg-white border border-gold/25 p-8 sm:p-12 shadow-sm">
                        <p className="eyebrow mb-3">Document légal</p>
                        <h1 className="font-heading font-extrabold text-forest text-3xl sm:text-4xl tracking-tight">{page.title}</h1>
                        {page.body?.includes("[À compléter") && (
                            <p className="mt-4 text-xs bg-gold/15 border border-gold/40 text-pineneedle rounded-lg px-4 py-3">
                                Certaines mentions obligatoires de ce document sont en cours de validation par l'éditeur et seront complétées avant la mise en production définitive.
                            </p>
                        )}
                        {page.body_html ? (
                            <RichText html={page.body_html} className="mt-8 text-pineneedle text-[15px]" testid="legal-body" />
                        ) : (
                            <div className="mt-8 space-y-4 text-pineneedle leading-relaxed text-[15px] whitespace-pre-line" data-testid="legal-body">{page.body}</div>
                        )}
                        {page.updated_at && (
                            <p className="mt-10 text-xs text-pineneedle/70">
                                Dernière mise à jour : {new Intl.DateTimeFormat("fr-FR", { dateStyle: "long" }).format(new Date(page.updated_at))}
                            </p>
                        )}
                    </article>
                )}
            </div>
        </main>
    );
}
